"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gte = gte;
function gte(num1, num2, options) {
  return num1 >= num2 ? options.fn(this) : options.inverse(this);
}